import { render } from "./SearchHeader.vue?vue&type=template&id=3448bb6b&scoped=true"
import script from "./SearchHeader.vue?vue&type=script&lang=js"
export * from "./SearchHeader.vue?vue&type=script&lang=js"

import "./SearchHeader.vue?vue&type=style&index=0&id=3448bb6b&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3448bb6b"]])

export default __exports__